<template>
  <div class="full-height">
    <q-card class="full-width full-height">
      <q-card-actions class="bg-accent text-white q-pa-md">
        <div class="title">Article Keywords</div>
        <q-space></q-space>
        <!-- <q-btn
          color="primary"
          style="width: 100px"
          class="q-mr-sm sustainability-button"
          @click="save"
        >
          Save
        </q-btn> -->
        <q-btn
          :loading="isLoading"
          style="width: 100px; background-color: #6dbf50"
          class="q-mr-sm sustainability-button"
          @click="save(true)"
        >
          Save & Add New
        </q-btn>
        <q-btn
          color="primary"
          style="width: 100px"
          :loading="isLoading"
          class="q-mr-sm sustainability-button"
          @click="save(false)"
        >
          Save & Close
        </q-btn>

        <q-btn @click="closeDialog" flat icon="mdi-close" size="5" round />
      </q-card-actions>
      <q-card-section>
        <div class="row">
          <div class="title">Info</div>
        </div>
        <q-form ref="form">
          <div class="row q-col-gutter-x-md">
            <div class="col-12">
              <q-input label="Keyword" v-model="formData.keyword"> </q-input>
            </div>
          </div>
        </q-form>
      </q-card-section>
    </q-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data: () => ({
    isLoading: false,
    formData: {},
  }),
  computed: {
    ...mapGetters({
      articlesList: "articles/list",
      data: "keywords/selectedKeyword",
    }),
  },
  mounted() {
    this.$store.dispatch("keywords/loadAll");
    this.init();
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.init();
      },
    },
  },
  methods: {
    init() {
      if (this.data != null) {
        this.formData = JSON.parse(JSON.stringify(this.data));
      }
      if (this.formData.status == "temp") {
        this.formData.status = "live";
      }
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    async save(addNew = false) {
      const isValid = await this.$refs.form.validate();
      if (isValid) {
        this.isLoading = true;
        let result = await this.$store.dispatch("keywords/save", this.formData);
        if (result.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message,
          });
          if (!addNew) {
            this.closeDialog();
          } else {
            let result = await this.$store.dispatch("keywords/new", {
              status: "temp",
            });
            this.$router.push(
              "/articlesKeywords/" + parseFloat(result.Response.newKeywordId)
            );
            this.$store.dispatch(
              "keywords/loadByID",
              parseFloat(result.Response.newKeywordId)
            );
          }
          this.isLoading = false;
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 13px;
}

.sustainability-button {
  min-width: 151px;
  height: 34px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 9px;
  line-height: 11px;
  display: flex;
  align-items: center;
  text-align: center;
}
</style>
